// extracted by mini-css-extract-plugin
export var box = "_87-1";
export var checked = "_87-2";
export var descriptionSpacer = "_87-9";
export var disabled = "_87-3";
export var icon = "_87-6";
export var input = "_87-0";
export var labelSpacer = "_87-8";
export var medium = "_87-5";
export var small = "_87-4";
export var text = "_87-7";